import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";

export const defaultTranslations = {
    pluginName: "Hubspot Form",
    pluginDescription: "Insert a Hubspot form.",
};

export const defaultSettings = {
    defaultText: "<p>Enter text here.</p>",

    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faEnvelope} size="3x" />,
};
